import { render, staticRenderFns } from "./CardMenuEntries.vue?vue&type=template&id=a4ef0906"
import script from "./CardMenuEntries.vue?vue&type=script&lang=js"
export * from "./CardMenuEntries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports